export const principalProductUserDefinedCategoryFieldMapping = [
  "principal_product_user_defined_category_id",
  "principal_id",
  "principal_code",
  "principal_name",
  "code",
  "value",
  "category_number",
];
